import $ from 'jquery';

export default class FaqBox {
  init() {
    const $question = $('.js-faq-box-question');

    $question.on('click', event => {
      const self = $(event.target);

      self.toggleClass('is-open');
      self
        .next()
        .slideToggle();
    });
  }
}
